import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";

interface ProfileFieldListCardProps {
  resources: Array<{ label: string; id: string; field_type: string }>;
}

export const ProfileFieldListCard = ({
  resources,
}: ProfileFieldListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.profile_fields")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_profile_fields_found")}
    renderItem={profileField => (
      <>
        <span className="text-darkest font-bold">{profileField.label}</span>{" "}
        <span className="text-darkest font-normal">
          ({profileField.field_type})
        </span>
      </>
    )}
    getItemKey={profileField => profileField.id}
  />
);
